export default "__VITE_ASSET__C_ikI4tY__"